<template>
  <div class="ficha-mapa ficha-uso-suelo">
    <div class="encabezado">Uso de suelo</div>
    <div class="contenedor">
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha3/1-Uso de suelo.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Ciudad de México</p>
          </div>
          <div class="ficha-titulo">
            <h4>Asentamientos</h4>
          </div>
          <div class="ficha-cuerpo">
            <ul class="m-t-0-md">
              <li>
                <b
                  >Los asentamientos humanos de la RNOCM abarcan el 19.9% de la
                  superficie</b
                >
                y se concentran en el Estado de México y Ciudad de México.
              </li>
              <li>
                Dentro del territorio estudiado,
                <b
                  >la población urbana asciende a 3 millones 639 mil habitantes
                  y la rural a 45 mil 067 habitantes.</b
                >
              </li>
              <li>
                La mayoría del área urbana actual se encuentra en terrenos con
                dificultades para su urbanización por las características del
                suelo y sus pendientes.
              </li>
              <li>
                <b
                  >El 69% de los municipios que integran la RNOCM cuentan con un
                  instrumento de planeación local.</b
                >
                Esto implica que 30% del territorio no tiene definidos programas
                y planes de ordenamiento y ecológicos territoriales a nivel
                municipal.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha3/2-Uso de suelo.png"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Zona industrial en Ecatepec</p>
          </div>
          <div class="ficha-titulo">
            <h4>Industria e infraestructura</h4>
          </div>
          <div class="ficha-cuerpo">
            <ul class="m-t-0-md">
              <li>
                En el RNOCM se localiza
                <b>la zona industrial más densa del país.</b>
              </li>
              <li>
                En la subcuenca de Texcoco, es visible la concentración de
                grandes industrias manufactureras, principalmente
                agroalimentarias. Algunas de ellas formas un círculo que "rodea"
                a la Zona Federal de Lago de Texcoco.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha3/3-Uso de suelo.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Zona agrícola</p>
          </div>
          <div class="ficha-titulo">
            <h4>Agrícultura e invernaderos</h4>
          </div>
          <div class="ficha-cuerpo">
            <ul class="m-t-0-md">
              <li>
                En la RNOCM
                <b
                  >la agrícultura es la actividad con mayor uso de suelo con
                  48.6% de la superficie</b
                >
                (42.1% de temporal y 6.5% de riego).
              </li>
              <li>
                La superficie de estos municipios asciende a alrededor de 113
                mil hectáreas y en ellas se producen alrededor de un millón 338
                mil 690 toneladas de productos agrícolas que representan un
                valor de más de 1,702 millones de pesos de derrama económica
                anual.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UsoDeSuelo",
};
</script>
